import React, { Component } from 'react';
import '../App.css';
import { Container, Col, Row } from 'reactstrap';
import { withLocalize, Translate } from 'react-localize-redux';
import axios from 'axios';

import { renderToStaticMarkup } from 'react-dom/server';
import Footer from '../components/Footer';
import Header from '../components/Header';

import ReviewForm from './ReviewForm';
import RecentReviewPanel from './RecentReviewPanel';
import globalTranslations from '../translations/global.json';

const onMissingTranslation = ({ defaultTranslation }) => defaultTranslation;


class Review extends Component {
  constructor(props) {
    super(props);

    const { initialize } = this.props;

    this.state = {
      isLoading: true,
    };
    initialize({
      languages: [
        { name: 'en', code: 'gb' },
        { name: 'fr', code: 'fr' },
      ],
      translation: globalTranslations,
      options: {
        defaultLanguage: 'gb',
        renderToStaticMarkup,
        onMissingTranslation,
      },
    });
  }

  async componentDidMount() {
    const { match, history } = this.props;

    const link = `/analytics/sites/${match.params.id}/`;

    await axios({
      method: 'get',
      url: link,
      crossdomain: true,
    })
      .then((res) => {
        const chsite = res.data;
        this.setState({ chsite, isLoading: false });
      })
      .catch((error) => {
        history.push('/404');
      });
  }


  renderForm() {
    const { chsite } = this.state;
    const { match, history } = this.props;
    return (
      <div className="App">
        <Header
          chsite={chsite}
        />
        <Container>
          <Row>
            <Col md="9" lg="8">
              <ReviewForm
                chsite={chsite}
                history={history}
              />
            </Col>
            <Col md="3" lg="4">
              <RecentReviewPanel
                chsiteId={match.params.id}
              />
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }

  render() {
    const { isLoading } = this.state;
    return isLoading
      ? <h4><Translate id="loading" /></h4> : this.renderForm();
  }
}

export default withLocalize(Review);
